import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const getTestDetails = (testId: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_TEST_DETAILS.METHOD](APIConfig.GET_TEST_DETAILS.URL(testId), {});
}

const addNewTest = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_NEW_TEST.METHOD](APIConfig.ADD_NEW_TEST.URL, payload);
}

const addNewICDCode = (panelCode: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_NEW_ICD_CODE.METHOD](APIConfig.ADD_NEW_ICD_CODE.URL(panelCode), payload, {});
}

// const getIcdCodes = (panelCode: any, payload: any) => {
//     // @ts-ignore
//     return ApiService[APIConfig.GET_ICD_CODE_LIST.METHOD](APIConfig.GET_ICD_CODE_LIST.URL(panelCode), payload, {});
// }

const downloadTestPanelCSV = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.TEST_PANEL_CSV_DOWNLOAD.METHOD](APIConfig.TEST_PANEL_CSV_DOWNLOAD.URL, payload);
}

const deleteIcdCodes = (testId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.DELETE_ICD_CODES.METHOD](APIConfig.DELETE_ICD_CODES.URL(testId), payload, {});
}

const editTestDetails = (testId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.EDIT_TEST_DETAILS.METHOD](APIConfig.EDIT_TEST_DETAILS.URL(testId), payload);
}
const addReportLayout = (testId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_REPORT_LAYOUT.METHOD](APIConfig.ADD_REPORT_LAYOUT.URL(testId), payload);
}
const getTestPanelListLite = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.TEST_LIST_LITE.METHOD](APIConfig.TEST_LIST_LITE.URL, payload);
}

const toggleTestPanel = (testId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.TOGGLE_TEST_PANEL_STATUS.METHOD](APIConfig.TOGGLE_TEST_PANEL_STATUS.URL(testId), payload);
}

const getICD10CodesList = (testId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_ICD_CODE_LIST_LITE.METHOD](APIConfig.GET_ICD_CODE_LIST_LITE.URL(testId), payload);
}

const addTestAttachment = (testId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_TEST_ATTACHMENTS.METHOD](APIConfig.ADD_TEST_ATTACHMENTS.URL(testId), payload);
}

const getTestAttachments = (testId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.TEST_ATTACHMENTS.METHOD](APIConfig.TEST_ATTACHMENTS.URL(testId), payload);
}

const deleteTestAttachment = (testId: any, attachmentId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.DELETE_TEST_ATTACHMENTS.METHOD](APIConfig.DELETE_TEST_ATTACHMENTS.URL(testId, attachmentId), payload);
}

const getStateReportDetails = (sessionID: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_STATE_REPORTING_VIEW.METHOD](APIConfig.GET_STATE_REPORTING_VIEW.URL(sessionID), {});
}

const getBiomarkerList = (sampleType: any, sampleCollectionDeviceName: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_BIOMARKER_LIST.METHOD](APIConfig.GET_BIOMARKER_LIST.URL(sampleType, sampleCollectionDeviceName), {});
}

const getBiomarkerListByIds=(payload:any)=>{
    return ApiService[APIConfig.GET_BIOMARKER_LIST_BY_IDS.METHOD](APIConfig.GET_BIOMARKER_LIST_BY_IDS.URL, payload);
}

const assignLabsToTest = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ASSIGN_LABS_TO_TEST.METHOD](APIConfig.ASSIGN_LABS_TO_TEST.URL, payload);
}

const getsAssignedLabsToTest = (testId: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_ASSIGNED_LABS_TO_TEST.METHOD](APIConfig.GET_ASSIGNED_LABS_TO_TEST.URL, {testId: testId});
}

const addTestPanel = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_TEST_PANEL.METHOD](APIConfig.ADD_TEST_PANEL.URL, payload);
}

const editTestPanel = (testPanelId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.EDIT_TEST_PANEL.METHOD](APIConfig.EDIT_TEST_PANEL.URL(testPanelId), payload);
}
const previewTestPanel=(payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.TEST_LAYOUT_PREVIEW.METHOD](APIConfig.TEST_LAYOUT_PREVIEW.URL, payload);
}

const toggleTestStatus = (testId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.TOGGLE_TEST_STATUS.METHOD](APIConfig.TOGGLE_TEST_STATUS.URL(testId), payload);
}

const removeConfiguration = (configId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.REMOVE_CONFIGURATION.METHOD](APIConfig.REMOVE_CONFIGURATION.URL(configId), payload);
}

const getTestListLite = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.TEST_LIST_LITE.METHOD](APIConfig.TEST_LIST_LITE.URL, payload);
}

const getTestReportType = () => {
    // @ts-ignore
    return ApiService[APIConfig.GET_TEST_REPORT_TYPE.METHOD](APIConfig.GET_TEST_REPORT_TYPE.URL);
}

const addTestIcdCode = (testId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_TEST_ICD_CODE.METHOD](APIConfig.ADD_TEST_ICD_CODE.URL(testId), payload);
}
const addTestCptCode = (testId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_TEST_CPT_CODE.METHOD](APIConfig.ADD_TEST_CPT_CODE.URL(testId), payload);
}

const TestService = {
    getTestDetails,
    addNewTest,
    editTestDetails,
    addReportLayout,
    toggleTestPanel,
    getTestPanelListLite,
    getICD10CodesList,
    addNewICDCode,
    getTestAttachments,
    addTestAttachment,
    // getIcdCodes,
    downloadTestPanelCSV,
    deleteIcdCodes,
    deleteTestAttachment,
    getStateReportDetails,
    getBiomarkerList,
    getBiomarkerListByIds,
    assignLabsToTest,
    addTestPanel,
    editTestPanel,
    previewTestPanel,
    toggleTestStatus,
    removeConfiguration,
    getsAssignedLabsToTest,
    getTestListLite,
    getTestReportType,
    addTestIcdCode,
    addTestCptCode,
}
export default TestService;
